import { isEqual, pick } from 'lodash';
import type { SelectedPositionPrice } from 'types/SelectedPositionPrice';

export const isPriceChanged = (
  oldPrice: SelectedPositionPrice,
  newPrice: { grossPrice: string; netPrice: string; isGrossEdited: boolean }
): boolean => !isEqual(pick(oldPrice, ['grossPrice', 'netPrice', 'isGrossEdited']), newPrice);
